<template>
  <div>
    <div v-if="newTabItems.length == 0" class="my-2">
      <b> Click Add Item to add new Row </b>
    </div>
    <v-form v-model="form" @submit.prevent ref="submitForm">
      <v-row class="my-2" v-for="(item, i) in newTabItems" :key="i">
        <v-col cols="6" md="2" sm="3">
          <div class="text-center my-1 mx-2">
            <span>Select Subject*</span>
          </div>
          <v-autocomplete
            label="Subject"
            :items="subjectItems"
            :rules="!item.is_break ? [rules.required] : []"
            v-model="item.subject"
            dense
            filled
            class="rounded-input"
            solo
            item-value="id"
            item-text="name"
            v-if="!item.is_break"
          >
          </v-autocomplete>
          <div class="text-center my-1 mx-2" v-else>
            <span>-</span>
          </div>
        </v-col>
        <v-col cols="6" md="2" sm="3">
          <div class="text-center my-1 mx-2">
            <span>Select Teacher*</span>
          </div>
          <v-autocomplete
            label="Teacher"
            :items="facultyItems"
            :rules="!item.is_break ? [rules.required] : []"
            v-model="item.faculty"
            dense
            filled
            class="rounded-input"
            solo
            item-value="id"
            item-text="full_name"
            v-if="!item.is_break"
          >
          </v-autocomplete>
          <div class="text-center my-1 mx-2" v-else>
            <span>-</span>
          </div>
        </v-col>
        <v-col cols="6" md="3" sm="3">
          <div class="text-center my-1 mx-2">
            <span>Time Slot*</span>
          </div>
          <!-- start time picker -->
          <v-autocomplete
            label="Time Slot"
            :items="slotItems"
            :rules="[rules.required]"
            v-model="item.time_slot"
            dense
            class="rounded-input"
            filled
            solo
            hide-details
            item-value="id"
            item-text="start_time"
          >
            <template v-slot:item="data">
              <template>
                <v-list-item-content>
                  <v-list-item-title
                  >
                  {{ moment(data.item.start_time, 'HH:mm:ss').format('LT') }} - {{ moment(data.item.end_time, 'HH:mm:ss').format('LT') }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </template>

            <template v-slot:selection="data">
              {{ moment(data.item.start_time, 'HH:mm:ss').format('LT') }} - {{ moment(data.item.end_time, 'HH:mm:ss').format('LT') }}
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="6" md="2" sm="3">
          <div class="text-center my-1 mx-2">
            <span>Room No.</span>
          </div>
          <v-text-field
            v-model="item.room_no"
            maxlength="5"
            placeholder="Room No."
            outlined
            dense
            class="rounded-input"
            v-if="!item.is_break"
          >
          </v-text-field>
          <div class="text-center my-1 mx-2" v-else>
            <span>-</span>
          </div>
        </v-col>
        <v-col cols="6" md="3" sm="12">
          <div class="text-center my-1 mx-4">
            <span>Actions</span>
          </div>
          <div class="text-center mx-2">
            <v-row>
              <v-col cols="6" md="3" sm="6" class="text-right">
                <div class="text-right">
                  <v-icon
                    class="red--text text--darken-2"
                    large
                    @click="deleteDialog(item, i)"
                  >
                    mdi-delete
                  </v-icon>
                </div>
              </v-col>
              <v-col cols="6" md="8" sm="6" align-self="center">
                <div class="text-center">
                  <v-switch
                    class="my-0"
                    color="primary"
                    label="Break"
                    v-model="item.is_break"
                    @change="switchAction(item)"
                  >
                  </v-switch>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" md="2" sm="4">
          <v-btn
            outlined
            block
            color="primary"
            class="my-2"
            @click="getCurrentTabItems()"
            :disabled="newTabItems.length == 0"
            id="reset-row"
          >
            Reset
          </v-btn>
        </v-col>

        <v-col cols="12" md="2" sm="4">
          <v-btn
            outlined
            block
            color="primary"
            class="my-2"
            id="add-row-item"
            @click="
              newTabItems.push({
                day: String(tab + 1),
                is_break: false,
                institution: currentInstitution.id,
              })
            "
          >
            Add Item
          </v-btn>
        </v-col>

        <v-col cols="12" md="2" sm="4">
          <v-btn
            color="primary"
            block
            :disabled="!form || isLoading || !newTabItems.length"
            class="my-2"
            id="save-timetable"
            @click="saveItems()"
          >
            Submit
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <DeleteConfirmationDialog
      title="Are you sure you want to delete this row?"
      :visible="showDeleteConfirmation"
      description="This action cannot be undone"
      @deleteObject="deleteItem"
    />
    <!-- snackbar -->
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" timeout="2000">
      {{ snackbar.text }}
      <template>
        <v-btn text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import api from "@api/index";
import endpoints from "@api/repository";
import DeleteConfirmationDialog from "@components/widgets/dialogs/DeleteConfirmationDialog.vue";
import TourHelper from "@utils/tour_helper";
// import Helper from "@utils/misc";

export default {
  name: "TimetableTabItems",
  components: { DeleteConfirmationDialog },
  props: {
    tab: {
      type: Number,
      default: 0
    },
    classId: {
      type: Number,
      default: null
    },
    facultyItems: {
      type: Array,
      default: () => []
    },
    subjectItems: {
      type: Array,
      default: () => []
    },
    slotItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: false,
      moment: moment,
      roomNo: null,
      rules: {
        required: value => !!value || "Required fields"
      },
      snackbar: {
        visible: false,
        text: "",
        color:"dark"
      },
      newTabItems: [],
      showDeleteConfirmation: false,
      breakSwitch: false,
      rowItem: {}
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "accessToken",
      "isLoading",
      "currentInstitution"
    ]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors
      };
    }
  },

  methods: {
    ...mapActions(["setLoading", "setActiveSessionData"]),

    handleTour() {
        var steps = [];
        steps.push({id: '1', description: "Fill in all necessary information(which are * marked), if break is selected then just timeslot is required."});
        steps.push({id: '2', description: "Reset the whole row information.", position:'top' ,el: '#reset-row'});
        steps.push({id: '3', description: "Select a classroom for further instructions", position:'top' ,el: '#add-row-item'});
        steps.push({id: '4', description: "Select a classroom for further instructions", position:'top' ,el: '#save-timetable'});
        TourHelper.startTour(this, "timetable__items", steps);
    },

    async handleApiErrors(err) {
        this.setLoading(false);
        if (err.response) {
            console.log(err.response);
            if(err.response.status == 400){
                var output = Object.values(err.response.data).toString();
                this.snackbar.text = output;
                this.snackbar.visible = true;
                this.snackbar.color = "error";

            }
        } 
        else {
            this.snackbar.text = "Unknown error occurred";
            this.snackbar.visible = true;
        }
        },

    async saveItems() {
      var time_slots = this.newTabItems.map(x => x.time_slot);
      if (new Set(time_slots).size != time_slots.length) {
        this.snackbar.visible = true;
        this.snackbar.text =
          "Multiple periods cannot have same time slots. Kindly Check again.";
        this.snackbar.color = "error";
        return;
      }

      this.newTabItems.forEach(obj => {
          obj.room = this.classId;
      });

      var response = await api.handleApi({
        apiEssentials: this.essentials,
        url: endpoints.createTimeTable,
        responseVar: response,
        method: api.Methods.POST, //POST
        body: this.newTabItems
      });

      if (response) {
        this.snackbar.visible = true
        this.snackbar.text = "Timetable Entry has been added"
        this.snackbar.color = "success"
        this.getCurrentTabItems()
      }
    },

    switchAction(item) {
      if (item.is_break) {
        item.room_no = null;
        item.faculty = null;
        item.subject = null;
      }
    },

    async getCurrentTabItems() {
      var url = endpoints.getTimeTableItems;
      url += "?room=" + `${this.classId}` + "&day=" + `${this.tab + 1}`;
      var response;
      response = await api.handleApi({
        apiEssentials: this.essentials,
        url: url,
        responseVar: response
      });

      if (response) {
        this.newTabItems = response;
      }
    },

    async deleteItem(confirm) {
      if (confirm) {
        var response = await api.call(
          this.essentials,
          endpoints.getTimeTableItems + `${this.rowItem.id}/`,
          api.Methods.DELETE //POST
        );

        if (response) {
          //snackbar confirmation
          this.snackbar.visible=true;
          this.snackbar.color="success";
          this.snackbar.text="Selected record has been deleted";
          this.getCurrentTabItems();
        }
      }

      this.showDeleteConfirmation = false;
      this.rowItem = {};
    },

    deleteDialog(value, index) {
      if (value.id) {
        this.rowItem = value;
        this.showDeleteConfirmation = true;
      } else {
        this.newTabItems.splice(index,1);
      }
    }
  },

  // watch: {
  //   classId: {
  //     async handler() {
  //       this.getCurrentTabItems();
  //     }
  //   },
  //   tab: {
  //     async handler() {
  //       this.getCurrentTabItems();
  //     }
  //   }
  // },

  created() {
    if (this.classId) {
      this.getCurrentTabItems();
    }
    this.handleTour();
  }
};
</script>